import React from 'react';
import { AlertRhombusIcon } from '../icons/icons/AlertRhombusIcon';
import './alertlabel.scss';

const AlertLabel = ({ text }: { text: string }) => {
    return (
        <div className="alertlabel">
            <AlertRhombusIcon width={24} height={24} />
            <span>{text}</span>
        </div>
    );
};

export default AlertLabel;
